
import up from 'react-addons-update';
import * as _ from 'lodash';
import moment from "moment-timezone";
// import "moment-timezone";


// Test if a dom element is child of one of the element in the isChildOf array
export function isElementChildOf (domElement, isChildOfDomElements) {
    var potentialParents = Array.isArray(isChildOfDomElements) ? isChildOfDomElements : [ isChildOfDomElements ];
    for (var i in potentialParents) {
        var parentElem = potentialParents[i];
        if(parentElem !== undefined)
            if(parentElem.contains(domElement))
                return true;
    }
    return false;
}






// React tools *****************************************************************

// Update an immutable object using "react-addons-update" module
export { up };

// Immutable object updater util.
// obj: The object you want to update/copy
// field: The field you want to update
// The new value
export const upVal = (obj, field, val) => up(obj, { [ field ] : { $set: val}});


// This one returns a result made for the "react-addons-update"
export class FieldFollower {
    // You pass in an object containing which field follow which field:  { driverField: [ followerField1, followerField2, ... ], ... }
    constructor(fieldsWithFollowers) {
        this.fields = fieldsWithFollowers;
    }

    autoFillOtherFields(baseObj, objChanges, field, newValue, changesToApply) {
        // If it has fields associated
        if(this.fields[field] !== undefined) {
            var autoFields = this.fields[field];
            var baseVal = (objChanges[field] !== undefined) ? objChanges[field] : baseObj[field];
                
            _.map(autoFields, (otherField) => {
                var otherVal = (objChanges[otherField] !== undefined) ? objChanges[otherField] : baseObj[otherField];
                if(otherVal === baseVal)
                    changesToApply[otherField] = { $set: newValue};
            });
        }
    }
}


// This automatically feed states in your react controls from TSRest ajax request.
export class AjaxStateFeeder {
    // TODO: Instead of the whole react control, it could be the setState function.
    constructor(reactCtl, tsRest) {
        this.reactCtl = reactCtl;
        this.tsRest = tsRest;
        this.reqToAbort = {};
    }

    // state: State name to feed
    // condition: Weither or not to execute the request, If not, null will be set in the state.
    // resourceUri: TSRest resource path
    feedState(state, condition, resourceUri) {
        var reqName = state + "Req", newState = {};

        // Abort already running req
        if(this.reqToAbort[reqName] !== undefined) this.reqToAbort[reqName].abort();

        // Set temp null state
        newState[state] = null;
        this.reactCtl.setState( newState );

        if(condition) {
            // Run the query
            var req = this.reqToAbort[reqName] = this.tsRest.get(resourceUri);
            
            // Process the result
            req.done(function(data){
                newState[state] = data;
                this.reactCtl.setState(newState);
            }.bind(this));
        }
    }

    abortAll(){
        for(var reqName in this.reqToAbort)
            this.reqToAbort[reqName].abort();
    }
}



// Val management
// Return if a variable is not null, not undefiend and not an arbitrary value. You can see this as not NullOrEmpty() in which you can tell what empty means to you.
export function notNullNor(val, andNotVal) { return val !== undefined && val !== null && val !== andNotVal; }


export function toDict (arr, keySelector) {
    return _.reduce(arr, function(acc, item) { acc[keySelector(item)] = item; return acc; }, {});
}

export function parseTwoLetterIsoLanguage(localeName) {
    return /^(\w\w)(-\w\w)?/.exec(localeName)[1].toLowerCase();
}
export function getMomentTZDateTime(dateTime, timezone) {
    return ((timezone !== undefined) ? moment.tz(dateTime, timezone) : moment(dateTime));
};

